import React, { useEffect, useState, useContext } from 'react'
import DashboardLayout from '../../layoutcontainers/DashboardLayout'
import MaterialDataGrid from '../../components/MaterialDataGrid'
import MaterialTypography from '../../components/MaterialTypography'
import { Card, CardHeader, Stack } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import MaterialButton from '../../components/MaterialButton'
import AddIcon from '@mui/icons-material/Add';
import { CheckCircle, Error, Info } from '@mui/icons-material'
import axios from 'axios';
import BASEURL from '../Utils/Baseurl';
import { useMaterialUIController } from '../../context';
import UserDetailsContext from '../../context/auth';
import { useUserDetails } from '../../context/auth'

const Holiday = () => {

    const navigate = useNavigate()
    const { user, AccessData } = useContext(UserDetailsContext);

    const { setviewdisplay } = useUserDetails()

    const id = user?.id;
    const [controller, dispatch] = useMaterialUIController()
    const { userAuthenticated } = controller

    const [pageState, setPageState] = useState({
        loading: false,
        error: false,
        message: "",
        state: 'init'
    })

    const [holidayList, setHolidayList] = useState([]);

    useEffect(() => {
        console.log("holidayList", holidayList);

    }, [])
    const holidayListTable = {
        columns: [
            {
                field: "event",
                headerName: "Event",
                flex: 1,
                editable: false,
                disableColumnMenu: true,
                sortable: true,
            },
            {
                field: "holidayType",
                headerName: "Holiday Type",
                flex: 1,
                disableColumnMenu: true,
                editable: false,
                sortable: true,
            },
            {
                field: "country",
                headerName: "Country",
                flex: 1,
                disableColumnMenu: true,
                editable: false,
                sortable: true,
            },
            {
                field: "eventDate",
                headerName: "Event Date",
                flex: 1,
                disableColumnMenu: true,
                editable: false,
                sortable: true,
            },           
           

        ],
        row: holidayList.map(holiday => {
            return (
                {
                    id: holiday.id,
                    country: holiday.country,
                    event: holiday.event?.toUpperCase(),
                    eventDate: holiday.eventDate,
                    holidayType: holiday.holidayType,
                    startDate: holiday.startDate,
                    endDate: holiday.endDate,
                }
            )
        }
        )

    }

    useEffect(() => {
        getHolidayList();
    }, []);


    const getHolidayList = async () => {
        const query = `    query{
  allHolidays{
    id
    country
    event
    holidayType
    startDate
    endDate
    lastupdate
    eventDate
  }
}

`;

        try {
            setPageState({ ...pageState, loading: true });

            const response = await axios.post(BASEURL, {
                query: query
            }, {
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            console.log('responseview:', response.data)

            const holidayList = response.data.data.allHolidays;
            setHolidayList(holidayList);
            setPageState({ ...pageState, loading: false, state: 'success' });

            console.log('Response:', holidayList);
        } catch (error) {
            console.error('ResponseError:', error);
            setPageState({ ...pageState, loading: false, error: true, message: error.message });
        }
    };



    const handleNewHoliday = () => {
        navigate('/holiday/add-holiday')
        setviewdisplay(false)
    }

    const holidayListClick = (e) => {
        setviewdisplay(true)
        if (e?.id) {
            navigate(`/holiday/holiday-details?id=${e?.id}`)
        }
    }

    return (
        <DashboardLayout>
            <Card >
                <CardHeader title={(
                    <Stack
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                        spacing={2}
                    >
                        <Stack direction="column" spacing={0}>
                            <MaterialTypography variant="h5" fontWeight="medium">
                                Holiday List
                            </MaterialTypography>
                            {/* <MaterialTypography variant="caption" color="text">
                                List of Holiday that you can get details of Holiday.
                            </MaterialTypography> */}
                        </Stack>
                        {AccessData &&
                            Array.isArray(AccessData) &&
                            AccessData.some(
                                (item) =>
                                    item.component === "AddHoliday" && item.can_access
                            ) && (
                                <MaterialButton
                                    variant="gradient"
                                    color="dark"
                                    size="small"
                                    startIcon={<AddIcon />}
                                    onClick={() => handleNewHoliday()}
                                >
                                    Holiday
                                </MaterialButton>
                            )}
                    </Stack>


                )} />
                <MaterialDataGrid
                    customHeight={500}
                    rows={holidayListTable.row}
                    columns={holidayListTable.columns}
                    checkboxSelection={false}
                    isSelectable={false}
                    onRowClick={holidayListClick}
                    loading={pageState.loading}
                    localeText={{
                        noRowsLabel: (
                            <Stack direction="column" alignItems="center" justifyContent="center" spacing={1}>
                                <MaterialTypography variant="body2" fontWeight="medium" color="text">
                                    No Holiday  found
                                </MaterialTypography>
                                <MaterialTypography variant="caption" color="text">
                                    You have not yet add any Holiday details. Click on the "Add Holiday " button to start adding Holiday.
                                </MaterialTypography>
                            </Stack>
                        )
                    }}
                />
            </Card>
        </DashboardLayout>
    )
}

export default Holiday
